import { styled, Typography } from '@mui/material';
import { motion } from 'framer-motion';

import { Icon } from '../../components/Icon';

export const AccountTypes = styled('section')(() => ({
  position: 'relative',
  width: '100%',
}));

export const Types = styled('div')(() => ({
  position: 'relative',
  width: '100%',
}));

export const Type = styled(motion.div)(({ theme }) => ({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
  gap: '28px',
  width: '100%',
  height: '166px',
  borderBottom: `1px solid ${theme.palette.color.divider}`,
  cursor: 'pointer',
  transition: 'padding var(--transition-ease-default)',

  '&:first-of-type': {
    borderTop: `1px solid ${theme.palette.color.divider}`,
  },
  '&:hover': {
    paddingLeft: '64px',

    '& .line, & .name': {
      color: theme.palette.color.fg.primary,
    },

    '& .glass-border': {
      color: theme.palette.color.fg.inversePrimary,
      backgroundColor: theme.palette.color.fg.foregroundFgPrimary,
      transition:
        'color var(--transition-ease-default), background-color var(--transition-ease-default)',

      '&::before': {
        display: 'none',
      },
    },

    '& .arrow': {
      color: theme.palette.color.fg.primary,
    },

    [theme.breakpoints.down('xl')]: {
      paddingLeft: '40px',
    },
    [theme.breakpoints.down('md')]: {
      paddingLeft: '0',
    },
  },

  [theme.breakpoints.down('2xl')]: {
    height: '124px',
  },
  [theme.breakpoints.down('xl')]: {
    gap: '20px',
  },
  [theme.breakpoints.down('md')]: {
    height: '106px',
  },
}));

export const Content = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  flex: '1 1 auto',
  gap: '28px',

  [theme.breakpoints.down('xl')]: {
    gap: '20px',
  },
  [theme.breakpoints.down('md')]: {
    gap: '16px',
  },
}));

export const Arrow = styled(Icon)(({ theme }) => ({
  width: 'auto',
  height: '40px',
  color: theme.palette.color.fg.tetriary,
  transition: 'color var(--transition-ease-default)',

  [theme.breakpoints.down('2xl')]: {
    height: '32px',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));

export const Line = styled(Typography)(({ theme }) => ({
  color: theme.palette.color.fg.tetriary,
  transition: 'color var(--transition-ease-default)',
}));

export const Name = styled(Typography)(({ theme }) => ({
  color: theme.palette.color.fg.tetriary,
  transition: 'color var(--transition-ease-default)',
}));

export const Img = styled(motion.img)(({ theme }) => ({
  position: 'absolute',
  zIndex: 1,
  top: '50%',
  right: '94px',
  width: '460px',
  pointerEvents: 'none',

  [theme.breakpoints.down('2xl')]: {
    right: '20px',
    width: '390px',
  },
  [theme.breakpoints.down('xl')]: {
    width: '300px',
  },
  [theme.breakpoints.down('md')]: {
    display: 'none',
  },
}));
